module.exports = ".orbit-editor, .orbit-editor-editor {\n  font-size: 9.5rem; }\n\n.orbit-editor-login {\n  font-size: 5rem; }\n\n.receipt {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 90%;\n  width: inherit; }\n\n.receipt .col {\n  border-radius: 10px !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/login/login.component.scss
// module id = ./src/app/components/login/login.component.scss
// module chunks = main